// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDQaYDLbYdMXQe7QlX1qvloO76B1Uuz7kM",
  authDomain: "solenca-f12fb.firebaseapp.com",
  projectId: "solenca-f12fb",
  storageBucket: "solenca-f12fb.appspot.com", // ✅ corrected .app → .appspot.com
  messagingSenderId: "603243248687",
  appId: "1:603243248687:web:d3db8da0340432f93a1ada",
  measurementId: "G-ZM7RCQ4EJB",
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);
export const analytics = getAnalytics(firebaseApp);

// Initialize Messaging (for push notifications)
export const messaging = getMessaging(firebaseApp);
